import { render, staticRenderFns } from "./LanguageSearchPage.vue?vue&type=template&id=34b06966&scoped=true&"
import script from "./LanguageSearchPage.vue?vue&type=script&lang=ts&"
export * from "./LanguageSearchPage.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageSearchPage.vue?vue&type=style&index=0&id=34b06966&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b06966",
  null
  
)

export default component.exports